module.exports = __webpack_public_path__ + "static/media/powerpoint.63f01939.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/powerpoint.svg
// module id = 39
// module chunks = 0